import Link from 'gatsby-link'
import styled from 'styled-components'

const Anchor = styled( Link )`
  cursor: pointer;
`
export { Anchor }
